import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import {
  dashboardClosureEvolutionFilterStartDateSelector,
  dashboardClosureEvolutionSelector,
  dashboardCountrySelectedSelector,
} from '../../../../state/selectors';
import ClosureEvolutionCard from './ClosureEvolutionCard';
import { ClosureEvolutionRow } from '../../../../types';
import {
  findDashboardClosureEvolutionRequested,
  changeDashboardCountrySelected,
  changeDashboardClosureEvolutionFilterEndAccountingDate,
  changeDashboardClosureEvolutionFilterStartAccountingDate,
  dashboardClosureEvolutionFilterEndDateSelector,
} from '../../../../state';
import { AccountingDateRangeFilter } from '../../../ReportFilters';

const DashboardClosureEvolution = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const countrySelected = useSelector(dashboardCountrySelectedSelector);

  // Fetch closure evolution data when the component mounts or when the selected country changes
  const resource = useSelector(dashboardClosureEvolutionSelector);

  const dateFilterConfig = {
    selectorStartDate: dashboardClosureEvolutionFilterStartDateSelector,
    selectorEndDate: dashboardClosureEvolutionFilterEndDateSelector,
    actionStartDate: changeDashboardClosureEvolutionFilterStartAccountingDate,
    actionEndDate: changeDashboardClosureEvolutionFilterEndAccountingDate,
  };

  const startDate = useSelector(dateFilterConfig.selectorStartDate);
  const endDate = useSelector(dateFilterConfig.selectorEndDate);

  <AccountingDateRangeFilter config={dateFilterConfig} spacing={1} />;
  useEffect(() => {
    if (!countrySelected) return;
    dispatch(findDashboardClosureEvolutionRequested());
  }, [dispatch, countrySelected, startDate, endDate]);

  return countrySelected ? (
    <Box width="100%">
      <AccountingDateRangeFilter config={dateFilterConfig} spacing={1} />
      <ClosureEvolutionCard
        title={`${t('dashboard.closure-evolution', { country: countrySelected })}`}
        data={(resource?.data as ClosureEvolutionRow[]) || []}
        loading={!!resource?.loading}
      />
    </Box>
  ) : null;
};

export default DashboardClosureEvolution;
